import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import * as firebase from 'firebase';
import * as moment from 'moment';
import Moment from 'react-moment';
import { Label } from 'react-bootstrap';
import NumberFormat from 'react-number-format';

import Backend from '../Layouts/Backend';
import ModalFormVehicleManagement from './ModalFormVehicleManagement';
import ModalFormVehicleTracker from './ModalFormVehicleTracker';
import { fbDataPurifier } from '../utils';

/* eslint-disable react/no-multi-comp */

class VehiclesManagement extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      vehicles: [],
      isFetching: false,
      order: {
        by: 'plate',
        asc: true,
      },
      showModalVehicle: false,
      showModalTracker: false,
      modalVehicle: {},
      modalTrackerVehicle: {},
    };

    this.saveVehicle = this.saveVehicle.bind(this);
    this.openModalNewVehicle = this.openModalNewVehicle.bind(this);
    this.hideModalNewVehicle = this.hideModalNewVehicle.bind(this);
    this.updateTracker = this.updateTracker.bind(this);
    this.openModalTracker = this.openModalTracker.bind(this);
    this.hideModalTracker = this.hideModalTracker.bind(this);
  }

  componentWillMount() {
    const { client: currentClient } = this.props.currentUser;

    if (currentClient) {
      this.fetchVehicles(currentClient);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { client: currentClient } = this.props.currentUser;
    const { client: nextClient } = nextProps.currentUser;

    if (currentClient !== nextClient) {
      this.fetchVehicles(nextClient);
    }
  }

  getVehiclesList() {
    const { order: { by, asc } } = this.state;
    return _.orderBy(this.state.vehicles, by, asc ? 'asc' : 'desc');
  }

  fetchVehicles(client) {
    this.setState({ isFetching: true });

    firebase
      .database()
      .ref(`/clients/${client}/vehicle/vehicles`)
      .once('value')
      .then((snapshot) => {
        const vehicles = _.map(snapshot.val() || {}, (vehicle, key) => ({
          $key: key,
          ...vehicle,
        }));

        this.setState({
          vehicles,
          isFetching: false,
        });
      })
      .catch(() => {
        this.setState({ isFetching: false });
      });
  }

  saveVehicle(formData, key) {
    const { client: currentClient } = this.props.currentUser;

    const ref = firebase.database().ref(`/clients/${currentClient}/vehicle/vehicles/${key}`);

    Promise.all(_.map(fbDataPurifier(formData), (data, child) => ref.child(child).set(data)))
      .then(() => _.delay(() => this.fetchVehicles(), 600));

    this.hideModalNewVehicle();
  }

  deleteVehicle(key) {
    const { client: currentClient } = this.props.currentUser;

    firebase.database().ref(`/clients/${currentClient}/vehicle/vehicles/${key}`)
      .update({ deleteOn: firebase.database.ServerValue.TIMESTAMP })
      .then(() => _.delay(() => this.fetchVehicles(), 600));
  }

  updateTracker(formData, key) {
    const {
      trackerKey,
      trackerSurrogate,
      trackerType,
      startTrackingTime,
    } = formData;
    const { client } = this.props.currentUser;

    const startMoment = moment(startTrackingTime, 'YYYY-MM-DDTHH:mm');

    const updates = {
      [`/clients/${client}/vehicle/tracking/status/${key}/tracker`]: {
        client,
        key: trackerKey,
        surrogate: trackerSurrogate,
      },
      [`/clients/${client}/vehicle/tracking/status/${key}/sync/lastParam`]: startMoment.valueOf(),
      [`/clients/${client}/vehicle/tracking/status/${key}/sync/${trackerType}Start`]: firebase.database.ServerValue.TIMESTAMP,
      [`/vehicles/${key}/client`]: client,
      [`/vehicles/${key}/tracker/${trackerType}Sync`]: startMoment.valueOf(),
    };

    Promise.all(_.map(updates, (data, ref) => {
      firebase.database().ref(ref)
        .set(data)
        .then((result) => { console.log(ref, data, result); })
        .catch((error) => { console.log(ref, data, error); });
    })).then(() => _.delay(() => this.fetchVehicles(), 600));

    this.hideModalTracker();
  }

  openModalNewVehicle() {
    this.setState({
      modalVehicle: {},
      showModalVehicle: true,
    });
  }

  openModalEditVehicle(vehicle) {
    this.setState({
      modalVehicle: { ...vehicle },
      showModalVehicle: true,
    });
  }

  hideModalNewVehicle() {
    this.setState({
      showModalVehicle: false,
    });
  }

  openModalTracker(vehicle) {
    this.setState({
      modalTrackerVehicle: { ...vehicle },
      showModalTracker: true,
    });
  }

  hideModalTracker() {
    this.setState({
      showModalTracker: false,
    });
  }

  render() {
    const results = this.getVehiclesList().map((vehicle) => {
      const result = [];

      const fleet = vehicle.fleet ? this.props.fleets[vehicle.fleet] || {} : {};

      result.push((
        <VehicleRow
          key={vehicle.$key}
          vehicle={vehicle}
          fleet={fleet}
          onTrackerClick={() => this.openModalTracker(vehicle)}
          onEditClick={() => this.openModalEditVehicle(vehicle)}
          onDeleteClick={() => console.log(vehicle)}
        />
      ));

      return result;
    });

    return (
      <Backend>
        <div className="content-inner">
          <div className="filter form-inline">
            <a
              className="button button-default button-icon"
              style={{ float: 'left', marginRight: '10px' }}
              onClick={this.openModalNewVehicle}
              onKeyPress={this.openModalNewVehicle}
              role="button"
              tabIndex={0}
            >
              <i className="md-icon">add</i>
            </a>
            <form>
              <div className="form-group">
                <input type="text" className="form-control" placeholder="Buscar..." />
              </div>

              <div className="form-group form-group-description">
                {this.state.isFetching ? 'Carregando veículos...' : 'Esta lista não é atualizada automaticamente'}
              </div>
            </form>
          </div>

          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th className="fixed-col">
                    <div className="status upcoming">
                      <i className="md-icon">lens</i>
                    </div>
                    {'Veículo'}
                  </th>
                  <th>Faturamento</th>
                  <th>Rastreamento</th>
                  <th>Frota</th>
                  <th />
                </tr>
              </thead>
              <tbody>{results}</tbody>
            </table>
          </div>

          <ModalFormVehicleManagement
            showModal={this.state.showModalVehicle}
            vehicle={this.state.modalVehicle}
            onAccept={this.saveVehicle}
            onCancel={this.hideModalNewVehicle}
          />

          <ModalFormVehicleTracker
            showModal={this.state.showModalTracker}
            vehicle={this.state.modalTrackerVehicle}
            onAccept={this.updateTracker}
            onCancel={this.hideModalTracker}
          />
        </div>
      </Backend>
    );
  }
}

VehiclesManagement.propTypes = {
  currentUser: PropTypes.shape({
    client: PropTypes.string,
    fleet: PropTypes.string,
  }).isRequired,
  fleets: PropTypes.object.isRequired,
};

export default connect(store => ({
  currentUser: store.authState.currentUser || {},
  fleets: store.fleetState.fleets || {},
}))(VehiclesManagement);

class VehicleRow extends PureComponent {
  render() {
    const { vehicle, fleet } = this.props;

    const lastPosition = _.get(vehicle, 'position', {});
    const lastTrip = _.get(vehicle, 'trip', {});

    return (
      <tr>
        {/* VEÍCULO */}
        <td className="fixed-col min-width">
          <div className="status upcoming">
            <i className="md-icon">lens</i>
          </div>

          <div className="title-wrapper">
            <div className="title">
              <Label bsStyle="default" style={{ fontSize: '85%' }}>
                {vehicle.plate}
              </Label>
              {'  '}
              <small>
                {vehicle.manufYear}/{vehicle.modelYear}
              </small>
            </div>
            <div className="subtitle">
              <small>
                {vehicle.brand} - {vehicle.model}
              </small>
            </div>
          </div>
        </td>

        {/* FATURAMENTO */}
        <td className="min-width">
          <div className="title-wrapper">
            <div className="title">
              <NumberFormat
                value={vehicle.monthRevenue || 0}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                displayType="text"
                prefix="R$ "
              />
            </div>
            <div className="subtitle">
              {lastTrip.issuedAt ? (
                <small>
                  <NumberFormat
                    value={lastTrip.freightAmount || 0}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={0}
                    displayType="text"
                    prefix="+R$ "
                  />
                  {' faturado '}
                  <Moment fromNow>{lastTrip.issuedAt}</Moment>
                </small>
              ) : (
                <small>Últ. viagem não encontrada</small>
              )}
            </div>
            <div className="subtitle">
              <small>
                {lastTrip.originCity && `${lastTrip.originCity} x ${lastTrip.destinationCity}`}
              </small>
            </div>
          </div>
        </td>

        {/* RASTREAMENTO */}
        <td>
          {!lastPosition.time ? (
            <div className="title-wrapper">
              <div className="title">
                <small>Sem informações do Rastreador</small>
              </div>
            </div>
          ) : (
            <div className="title-wrapper">
              <div className="title">
                <small>
                  <Label bsStyle={lastPosition.ignition ? 'primary' : 'default'}>
                    {lastPosition.speed} km/h
                  </Label>
                  {'  '}
                  <Moment fromNow>{lastPosition.time}</Moment>
                </small>
              </div>
              <div className="subtitle">
                <Moment format="DD/MM HH:mm">{lastPosition.time}</Moment>
                {' em '}
                {lastPosition.city}
              </div>
              {lastPosition.detail && <div className="subtitle">{lastPosition.detail}</div>}
            </div>
          )}
        </td>

        {/* FROTA */}
        <td className="min-width">
          <div className="title-wrapper">
            <div className="title">
              <Label bsStyle={fleet.name ? 'primary' : 'danger'} style={{ fontSize: '85%' }}>
                {fleet.name || 'N/D'}
              </Label>
            </div>
          </div>
        </td>

        {/* AÇÕES */}
        <td className="actions min-width">
          <span hidden>{vehicle.$key}</span>
          <div className="button-group">
            <button className="button" onClick={this.props.onTrackerClick}>Rastreador</button>
            <button className="button" onClick={this.props.onEditClick}>Editar</button>
            <button className="button danger" onClick={this.props.onDeleteClick}>
              Deletar
            </button>
          </div>
        </td>
      </tr>
    );
  }
}

VehicleRow.propTypes = {
  vehicle: PropTypes.object.isRequired,
  fleet: PropTypes.object.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onTrackerClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/Vehicle/VehiclesManagementPage.js